export default "__VITE_ASSET__05ec524d__"